import * as styles from "./modal.module.scss"

import React, { useEffect, useState } from "react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/pro-light-svg-icons"

const Modal = ({ className, isOpen, onClose, children, overlayColor, closeBtnColor }) => {
  const classes = [styles.modal]
  className && classes.push(className)
  isOpen && classes.push(styles.active)

  const [open] = useState(isOpen)

  useEffect(() => {
    const html = document.querySelector('html')
    open ? (html.style.overflow = 'hidden') : (html.style.overflow = 'visible')
    return () => html.style.overflow = 'visible'
  }, [open])
  
  return (
    <div className={ classes.join(' ') }>
      <div className={ styles.overlay } style={{background: overlayColor}}>
        <button aria-label="close modal" onClick={ onClose } style={{ color: closeBtnColor || '#ffffff' }}><FontAwesomeIcon icon= {faTimes}></FontAwesomeIcon></button>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              { children }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal